var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmazon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#191619",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M41.462 40.25C36.458 44.003 29.202 46 22.955 46 14.2 46 6.315 42.71.348 37.234c-.469-.43-.05-1.017.512-.684 6.438 3.807 14.398 6.1 22.62 6.1 5.547 0 11.644-1.17 17.254-3.588.846-.365 1.556.567.728 1.188zm2.082-3.386c-.64-.833-4.231-.395-5.844-.198-.489.06-.565-.374-.124-.689 2.864-2.045 7.558-1.454 8.103-.77.55.691-.143 5.474-2.828 7.756-.413.351-.806.164-.623-.3.604-1.533 1.957-4.966 1.316-5.799z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.177.71c-.35-.318-.853-.34-1.246-.125-1.753 1.48-2.066 2.164-3.024 3.573C24.012 1.16 21.961.261 18.21.261c-4.441 0-7.895 2.785-7.895 8.356 0 4.352 2.32 7.311 5.626 8.762 2.862 1.276 6.859 1.508 9.917 1.857v.696c0 1.277.1 2.785-.64 3.888-.642.986-1.876 1.392-2.961 1.392-2.012 0-3.801-1.047-4.24-3.219-.092-.483-.438-.96-.917-.985l-5.112.562c-.432.1-.912.45-.787 1.12 1.175 6.305 6.776 8.21 11.795 8.21 2.567 0 5.922-.697 7.946-2.67 2.565-2.437 2.319-5.687 2.319-9.227v-8.352c0-2.512 1.026-3.614 1.99-4.968.337-.488.413-1.068-.016-1.424a230.271 230.271 0 0 1-4.046-3.56l-.012.011zm-5.319 13.071c0-2.09.05-3.83-.986-5.687-.839-1.509-2.17-2.437-3.652-2.437-2.023 0-3.207 1.567-3.207 3.888 0 4.566 4.03 5.396 7.845 5.396v-1.16z",
    transform: "matrix(1 0 0 -1 0 31.16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazon);
export default __webpack_public_path__ + "static/media/amazon.47de085da2d8c24b32724b0ec057402a.svg";
export { ForwardRef as ReactComponent };